module.exports = __webpack_public_path__ + "img/like-small.f5fcbc3b.svg";